import { UploadImage, updateSelfEmployee } from "../../Actions/actions";
import React, { useEffect, useRef, useState } from "react";
import { FaCamera } from "react-icons/fa";
import Input from "../Input/Input";
import AuthButton from "../AuthButton/AuthButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Loader from "../Loader/Loader";

const EmplyeeProfile = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const { loginData, subLoader } = useSelector((state) => state.userReducer);

  const [errors, setErrors] = useState({});
  const [logo, setLogo] = useState(null);

  const [formData, setFormData] = useState({
    FullName: "",
    phoneNumber: "",
    countryCode: "+971",
    logo: "",
  });

  useEffect(() => {
    setFormData({
      FullName: loginData?.employeeData?.FullName || "",
      phoneNumber: loginData?.employeeData?.phoneNumber || "",
      countryCode: loginData?.employeeData?.countryCode || "",
      logo: loginData?.employeeData?.logo || "",
    });
  }, [loginData?.employeeData]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.FullName) {
      newErrors.FullName = "Full Name is required";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Contact Number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(
        updateSelfEmployee(
          loginData?.employeeData?.id,
          formData,
          loginData?.accessToken
        )
      );
    }
  };

  const handleLogoClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      dispatch(
        UploadImage(file, loginData?.accessToken, (data) => {
          setFormData({ ...formData, logo: data.data.fileUrl });
          setLogo(data.data.fileUrl);
        })
      );
    }
  };

  return (
    <div className="flex md:space-x-8 sm:space-y-8 sm:flex-col md:flex-row  ">
      <div className="sm:w-full md:w-2/5 bg-white p-2 sm:py-10 md:py-0 rounded-lg shadow-lg flex flex-col  items-center justify-center">
        <div
          className="rounded-full bg-gray-200 mb-4 relative"
          onClick={handleLogoClick}
        >
          <img
            src={
              logo ? logo : formData.logo || "https://via.placeholder.com/150"
            }
            className="w-36 h-36 object-cover rounded-full bg-gray-200 shadow-md "
          />
          {logo || formData.logo ? null : (
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <FaCamera className="w-7 h-7 mb-1" />
              <p className="text-black text-sm text-center">Upload Logo</p>
            </div>
          )}
          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleLogoUpload}
          />
        </div>

        <p className="text-gray-500 text-sm text-center">
          Allowed *.jpeg, *.jpg, *.png{" "}
        </p>
      </div>

      <div className="sm:w-full  md:w-3/5 bg-white p-8 rounded-lg shadow-lg">
        <form className="">
          <div className="grid grid-cols-1  xl:grid-cols-2 gap-6 mb-6 ">
            <div>
              <Input
                float
                type="text"
                label={"Full Name"}
                placeholder="Full Name"
                value={formData.FullName}
                error={errors.FullName}
                onChange={(e) => {
                  setErrors({ ...errors, FullName: "" });
                  setFormData({
                    ...formData,
                    FullName: e.target.value,
                  });
                }}
              />
            </div>
            <div>
              <Input
                float
                isPhoneNumber
                countryCodeValue={formData.countryCode}
                placeholder="Contact Number"
                value={formData.phoneNumber}
                error={errors.phoneNumber}
                onCountryChange={(newCountryCode) => {
                  setFormData((prev) => ({
                    ...prev,
                    countryCode: newCountryCode,
                  }));
                }}
                onChange={(e) => {
                  setErrors({ ...errors, phoneNumber: "" });
                  setFormData({
                    ...formData,
                    phoneNumber: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <div className="flex justify-end">
            {subLoader ? (
              <Loader />
            ) : (
              <AuthButton
                width={"20%"}
                title={"Save Changes"}
                className="px-4 py-2  text-white rounded-md"
                onClick={(e) => {
                  handleSubmit(e);
                }}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmplyeeProfile;
